<div
  class="wsu-confirm-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  [attr.data-testid]="testId"
>
  <div class="wsu-confirm-modal" [class.wsu-confirm-modal--blue]="accent === 'blue'">
    <h2 [id]="titleId" class="wsu-confirm-modal__title" [attr.data-testid]="testId + '-title'">
      {{ title }}
    </h2>
    <div class="wsu-confirm-modal__text">
      <ng-content></ng-content>
    </div>
    <div class="wsu-confirm-modal__actions">
      <button
        type="button"
        class="btn btn-outlined btn-medium"
        [attr.data-testid]="testId + '-cancel-button'"
        [disabled]="busy"
        (click)="cancel.emit()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary btn-medium"
        [attr.data-testid]="testId + '-confirm-button'"
        [disabled]="busy"
        (click)="confirm.emit()"
      >
        {{ busy ? busyLabel : confirmLabel }}
      </button>
    </div>
  </div>
</div>
